export interface GuFaq {
  question: string;
  answer: string;
}

export const guFaqs: GuFaq[] = [
  {
    question: "瓜田观察主要收录哪些内容？",
    answer:
      "我们以网红吃瓜事件为核心，重点收录评论区风向、网友热议、神评翻车和评论区沦陷现场。简单说，我们不只是搬运事件本身，而是把「大家怎么评价这场瓜」当成第一手信息来整理。",
  },
  {
    question: "评论区的数据是怎么统计的？",
    answer:
      "我们会抓取公开可见的高赞评论与回复，按人工分类为支持、反对和中性三类，统计出情绪比例，并挑选出最具代表性的热评与神评展示在详情页。所有结论都标注为观察统计，不代表平台立场。",
  },
  {
    question: "为什么不同事件的评论区风向差别这么大？",
    answer:
      "风向量取决于事件本身的可讨论空间。比如价格争议类事件证据清晰，评论区容易一边倒；而情感类事件信息模糊，网友更容易分成互不相让的两派。这也是看评论区比看正文更有意思的原因。",
  },
  {
    question: "这里的事件内容会不会有失实的情况？",
    answer:
      "我们坚持只做公开信息的聚合与整理，不添油加醋，也不替任何一方下定论。如果你发现某条内容与事实不符，可以通过页面底部的邮箱联系我们，我们会在核实后尽快修正或下架。",
  },
  {
    question: "吃瓜时可以留言参与讨论吗？",
    answer:
      "目前我们以聚合展示为主，你可以通过订阅每日速报第一时间收到更新。未来我们会开放投稿与讨论入口，让评论区真正成为吃瓜群众自己的地盘。",
  },
];